export const environment = {
  production: true,
  apiUrl: 'https://www3.tjrj.jus.br/SCPEWEB/api/',
  versao:'1.3.1',
  ambiente: '',
  campoObrigatorio: 'Campo obrigatório.',
  campoEmail: 'Deve ser preenchido um endereço de e-mail válido.',
  campoTurno: 'As opções de turnos não podem ser iguais.',
  campoTelefone: 'Informe pelo menos um contato telefônico.'
};
